import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import _isEmpty from 'lodash/isEmpty';
import { DEFAULT_ANIMATION_DURATION, PROPS_BY_TRANSITION, TRANSITIONS_BY_ANIMATION } from '../animation.constants';
export function getAnimationWithDefaults() {
  var animation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _ref = animation || {},
    name = _ref.name,
    duration = _ref.duration,
    _ref$transitionProps = _ref.transitionProps,
    transitionProps = _ref$transitionProps === void 0 ? {} : _ref$transitionProps;
  if (_isEmpty(animation) || _isEmpty(name)) {
    return {};
  }
  return {
    name: name,
    duration: duration || DEFAULT_ANIMATION_DURATION,
    transitionProps: transitionProps
  };
}
export function getTransitionPropsWithDefaults(transition, transitionProps) {
  var defaultProps = PROPS_BY_TRANSITION[transition];
  return _objectSpread(_objectSpread({}, defaultProps), transitionProps);
}
export function getTransitions(animationName) {
  return TRANSITIONS_BY_ANIMATION[animationName] || [];
}